import { getAllMatches } from '@/utils/regex'
import { mdToHtml } from '@/utils/markdown'

function removeMdFromText(mdText, store) {
  const div = document.createElement('div')
  div.innerHTML = mdToHtml(mdText, store)
  const textWithoutMd = div.textContent || div.innerText || ''
  return textWithoutMd
}

export default {
  getNoteById: (state, { noteRelations }) => noteId => {
    if (noteId) {
      const note = Object.assign({ title: '', content: '', created: 0, modified: 0 }, state.notes[noteId] || {})
      note.id = noteId
      note.content = note.content || ''
      note.wordCount = note.content.split(' ').length
      note.links = noteRelations[note.id]
      return note
    } else {
      return {}
    }
  },
  getNoteIdByTitle: (state, { rawNotes }) => title => (rawNotes.find(note => note.title === title) || {}).id,
  getNoteLinksByNoteId: (state, getters) => noteId => {
    if (noteId) {
      const note = state.notes[noteId] || {}
      const regex = /\[\[(.*?)\]\]/g
      const links = getAllMatches(regex, note.content || '')
        .map(to => getters.getNoteIdByTitle(to[1]))
        .filter(id => Object.keys(state.notes).includes(id))
      const prefix = state.contextedPrefix
      const regexOldLinks = new RegExp(`\\[.*?\\]\\(${prefix}(.*?)\\)`, 'g')
      const oldLinks = getAllMatches(regexOldLinks, note.content || '').map(to => to[1]).filter(id => Object.keys(state.notes).includes(id))
      return [...oldLinks, ...links]
    } else {
      return []
    }
  },
  getNoteByTitle: (state, getters) => title => {
    return getters.notes.find(p => p.title === title)
  },
  rawNotes: state => Object.keys(state.notes).map(noteId => Object.assign({}, state.notes[noteId], { id: noteId })),
  notes: (state, { getNoteById }) => {
    return Object.keys(state.notes).map(id => getNoteById(id))
  },
  noteRelations: (state, { getNoteLinksByNoteId }) => {
    const relations = Object.keys(state.notes)
      .filter(id => id !== undefined)
      .map(id => {
        const to = getNoteLinksByNoteId(id)
        return { id, to }
      })
      .map((note, index, noteRelations) => ({
        ...note,
        from: [...noteRelations]
          .map(noteRelation => noteRelation.to.filter(toId => toId === note.id).map(() => noteRelation.id))
          .reduce((arr, elem) => arr.concat(elem), [])
          .filter((value, index, self) => self.indexOf(value) === index)
      }))
      .reduce((notes, { id, to, from }) => {
        notes[id] = { to, from }
        return notes
      }, {})
    return relations
  },
  notesList(state) {
    return Object.keys(state.notes)
  },
  rootNote: (state, getters) => {
    return getters.notes.find(note => note.isRoot)
  },
  viewMode(state) {
    return state.viewMode
  },
  breadcrumb(state, getters) {
    try {
      const contextion = state.route.params.contextion
      const breadcrumb = contextion ? atob(contextion).split(';') : [getters.rootNote.id]
      const noteIds = getters.notes.map(p => p.id)
      const breadcrumbValid = breadcrumb.every(noteId => noteIds.indexOf(noteId) >= 0)
      return breadcrumbValid ? breadcrumb : []
    } catch {
      return []
    }
  },
  currentNote(state, getters) {
    if (getters.breadcrumb.length > 0) {
      const noteId = getters.breadcrumb.slice(-1)[0]
      const note = getters.getNoteById(noteId)
      return note
    } else {
      return null
    }
  },
  // links(state, getters) {
  //   const countUnique = arr => arr.reduce((count, value) => {
  //     count[value] = ++count[value] || 1
  //     return count
  //   }, {})
  //   const currentNote = getters.currentNote || { links: { to: [], from: [] } }
  //   const linksWithCount = ['to', 'from'].reduce((links, linkType) => {
  //     const linkCount = countUnique(currentNote.links[linkType])
  //     const linkedNotes = Object.keys(linkCount).map(noteId => {
  //       return {
  //         ...getters.getNoteById(noteId),
  //         count: linkCount[noteId]
  //       }
  //     })
  //     links[linkType] = linkedNotes.sort((a, b) => b.count - a.count).slice(0, 3)
  //     return links
  //   }, {})
  //   return linksWithCount
  // },
  notesByQuery: (state, getters) => (query, { titleOnly } = { titleOnly: false }) => {
    return getters.notes.filter(({ title, content }) => {
      const resultTitle = title.toLowerCase().includes(query.toLowerCase())
      const resultContent = removeMdFromText(content, { state, getters }).toLowerCase().includes(query.toLowerCase())
      return resultTitle || (!titleOnly && resultContent)
    })
  }
}
